var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"goods-empty"},[_c('app-header',{attrs:{"title":_vm.title,"back-type":"back-app"}}),_c('div',{staticClass:"goods-empty-image"}),_c('div',{staticClass:"goods-empty-label"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }